import { Route, Routes } from 'react-router-dom';
import { routesList } from './RoutesList';
import BakeasyAppLayout from '../components/layouts/BakeasyAppLayout';
import { PrivateRoutes } from './PrivateRoutes';
import { BakeasyAccountLayout } from '../components/layouts/BakeasyAccountLayout';
import { Stores } from '../pages/Stores/Stores';

function AppRoutes() {
  // init custom history object to allow navigation from
  // anywhere in the react app (inside or outside components)
  // history.location = useLocation();
  // history.navigate = useNavigate();

  return (
    <Routes>
      {/* private */}
      <Route element={<PrivateRoutes />}>
        <Route path="/" element={<BakeasyAppLayout component={<Stores />} />} />
        {routesList.map((routeItem: any, index) => (
          <Route
            key={index}
            path={routeItem?.path}
            element={<BakeasyAppLayout component={<routeItem.component />} />}
          />
        ))}
      </Route>
      {/* public */}
      <Route path="/*" element={<BakeasyAccountLayout />} />
    </Routes>
  );
}

export default AppRoutes;
